import React, { ReactElement } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import COLORS from '~/constants/colors';
import { FONT_SIZES } from '~/constants/typography';
import FramedView from '~/components/FramedView';
import Announcement from '~/components/Announcement';
import Button from '~/components/buttons/Button';
import Title from '~/components/titles/Title';
import VARIANTS from '~/constants/variants';
import Break from '~/components/flow/Break';
import { stopEventEffects } from '~/utils';

import PATHS from '../constants/paths';

function NoLoad(): ReactElement {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { redirect } = state ?? {};
  const handleGoBack = (event) => {
    stopEventEffects(event);
    navigate(redirect || PATHS.menu);
  };

  // Styling
  const noLoadStyle = {
    width: 'min(45em, 82.5vw)',
  };
  const frameColors: [string, string] = [
    COLORS.waikawaGray,
    COLORS.waikawaGray,
  ];
  const buttonStyle = {
    width: '9em',
    margin: '0 0.25em 0.38em',
    boxShadow: `-0.1em 0.1em ${COLORS.black25}`,
    borderStyle: 'none',
    fontSize: FONT_SIZES.text,
  };

  return (
    <FramedView accent colors={frameColors} style={noLoadStyle}>
      <Title>Frozen Yogurt</Title>
      <br />
      Oof, looks like your connection is too weak, this song isn&apos;t
      available on your device, or the uploader has blocked you and the game got
      stuck trying to load it. Please use the preview button to check if you
      have access and can even view your selection properly.
      <Break />
      <Announcement header="Note" variant={VARIANTS.warning}>
        It&apos;s possible the issue is caused by a slow browser and waiting a
        bit before starting the game can give enough time for the code to run.
        While not common, I&apos;ve seen this sometimes when the device is too
        old with recent versions of Safari that behave less stably.
      </Announcement>
      <br />
      <Button
        label="Go Back"
        onClick={handleGoBack}
        onTouchEnd={handleGoBack}
        style={buttonStyle}
      />
    </FramedView>
  );
}

export default NoLoad;
